/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Text } from '../text';
import { has, is } from '../../services';
import { Icon } from '../icon';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Textarea Component
 * @param disabled {boolean} Disabled textarea
 * @param name {string} Textarea name
 * @param onChange {Function} OnChange textarea Event
 * @param placeholder {string} Placeholder textarea
 * @param defaultValue {string} Default Value for textarea
 * @param help {string} Help for textarea
 * @param ref Pass a ref for textarea
 * @param maxLength {number} Textarea max length
 * @param rows {number} Textarea rows
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 * @param hovered {boolean} Hover mode
 * @param focused {boolean} Fucus mode
 * @param minLength {number} Textarea min length
 * @param status {InputStatus} Textarea with status - (SUCCESS|WARNING|ERROR|DEFAULT)
 * - -------------------------- NATIVE PROPERTIES -------------------------------
 * @param keyboardStyle {InputKeyboardAppearance} Custom appearance for keyboard
 * @param autoCapitalize {InputAutoCapitalize} Capitalize => NONE | SENTENCES | WORDS | CHARS
 * @param autoCorrect {boolean} Auto correct sentence
 * @param autoCompleteType {InputAutoCompleteType} Auto complete input type
 * @param textContentType {InputTextContentType} Give the keyboard and the system information
 * @param keyboardType {InputKeyboardType} Keybaord type
 */
const Textarea = ({ className, disabled, onChange, focused = true, placeholder, defaultValue, hovered = true, help, status, statusIconName, dynamicPlaceholder = true, rows, ref, label, maxLength, minLength, iconName, typo, testId, ...others }) => {
    const [value, setValue] = useState(defaultValue || '');
    const { styled } = useTrilogyContext();
    useEffect(() => {
        setValue(defaultValue || '');
    }, [defaultValue]);
    const wrapperClasses = hashClass(styled, clsx('textarea-wrapper', className, status && is(status)));
    const classes = hashClass(styled, clsx('textarea', dynamicPlaceholder && has('dynamic-label'), iconName && has('icon')));
    const helpClasses = clsx('help');
    const counterClasses = hashClass(styled, clsx('counter', maxLength));
    return (React.createElement("div", { className: wrapperClasses },
        !dynamicPlaceholder && React.createElement("label", null, label),
        React.createElement("textarea", { "data-testid": testId, minLength: minLength, disabled: disabled, ref: ref, ...others, className: classes, value: value, onChange: (e) => {
                setValue(e.target.value);
                if (onChange) {
                    onChange({
                        textareaName: e.target.name,
                        textareaValue: e.target.value,
                    });
                }
            }, placeholder: placeholder, rows: rows, maxLength: maxLength }),
        dynamicPlaceholder && React.createElement("label", null, label),
        iconName && React.createElement(Icon, { name: iconName, size: 'small' }),
        statusIconName && React.createElement(Icon, { name: statusIconName, size: 'small' }),
        help && (React.createElement(Text, { typo: typo, className: helpClasses }, help)),
        maxLength && React.createElement("div", { className: counterClasses }, `${value.length}/${maxLength === null || maxLength === void 0 ? void 0 : maxLength.toString()}`)));
};
export default Textarea;
//# sourceMappingURL=Textarea.js.map